import { render } from "./BeneficiosEs.vue?vue&type=template&id=49a4650e&scoped=true"
import script from "./BeneficiosEs.vue?vue&type=script&lang=js"
export * from "./BeneficiosEs.vue?vue&type=script&lang=js"

import "./BeneficiosEs.vue?vue&type=style&index=0&id=49a4650e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a4650e"]])

export default __exports__